import { useTranslation } from "react-i18next";
import { DEPT_ICONS, DEPT_ICON_KEYS, DEPT_COLORS } from "./deptIcons";

// منتقي الأيقونة واللون — 60+ أيقونة (شبكة متمرّرة) + 28 لونًا.
export const DeptIconPicker = ({ iconKey, color, onIcon, onColor }) => {
  const { t } = useTranslation();
  const active = color || DEPT_COLORS[0];
  return (
    <div className="grid gap-5" data-testid="dept-appearance">
      <div>
        <div className="mb-2 flex items-center justify-between">
          <p className="text-[11px] font-bold uppercase tracking-wider text-muted-foreground">
            {t("departments.form.icon")}
          </p>
          <span className="num font-mono text-[10px] text-muted-foreground">
            {DEPT_ICON_KEYS.length}
          </span>
        </div>
        <div className="grid max-h-[240px] grid-cols-7 gap-1.5 overflow-y-auto rounded-2xl border border-border/40 bg-muted/20 p-2 sm:grid-cols-8">
          {DEPT_ICON_KEYS.map((k) => {
            const Icon = DEPT_ICONS[k];
            const on = iconKey === k;
            return (
              <button key={k} type="button" data-testid={`dept-icon-${k}`}
                      onClick={() => onIcon(k)} title={k}
                      className={`flex h-10 w-10 items-center justify-center rounded-xl transition ${
                        on ? "shadow-neu-in scale-95" : "shadow-neu-sm hover:brightness-110 hover:-translate-y-0.5"}`}
                      style={on ? { color: active, background: `${active}22` } : {}}>
                <Icon className="h-4 w-4" />
              </button>
            );
          })}
        </div>
      </div>
      <div>
        <div className="mb-2 flex items-center justify-between">
          <p className="text-[11px] font-bold uppercase tracking-wider text-muted-foreground">
            {t("departments.form.color")}
          </p>
          <span className="num font-mono text-[10px] text-muted-foreground">
            {DEPT_COLORS.length}
          </span>
        </div>
        <div className="grid grid-cols-7 gap-2 sm:grid-cols-8">
          {DEPT_COLORS.map((c) => {
            const on = active.toLowerCase() === c.toLowerCase();
            return (
              <button key={c} type="button" data-testid={`dept-color-${c}`}
                      onClick={() => onColor(c)} title={c}
                      className={`h-8 w-8 rounded-full transition ${
                        on ? "ring-2 ring-offset-2 ring-offset-background scale-110" : "hover:scale-110"}`}
                      style={{ background: c }} />
            );
          })}
        </div>
      </div>
    </div>
  );
};
